import { css, type Theme } from "@emotion/react";

import { layers } from "@styles";

const baseStyles = (theme: Theme) => css`
  border-color: transparent;
  box-shadow: ${theme.boxShadows.popoverBase};
  z-index: ${layers.zIndexLowForegroundPlus};
  path {
    fill: ${theme.text.emphasis};
  }
`;

export const button = (theme: Theme) => css`
  ${baseStyles(theme)}
  background: ${theme.surface.interactiveBackground};
  opacity: 0;

  &:hover,
  &:active {
    ${baseStyles(theme)}
  }

  &:hover {
    background: ${theme.surface.interactiveHover};
  }

  &:active {
    background: ${theme.surface.interactiveActive};
  }
`;

export const focused = (isFocused: boolean) => css`
  opacity: ${isFocused ? 1 : 0};
`;

export const positioning = {
  base: css`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  `,
  previous: css`
    left: -20px;
  `,
  next: css`
    right: -20px;
  `,
};
